/**
 * Side Cart - MakeMyMask
 * Script minimaliste qui utilise CartUtils
 * 
 * Ce fichier est maintenant simplifié car toute la logique
 * est centralisée dans cart-utils.js
 */

(function() {
  'use strict';

  // Attendre que CartUtils soit disponible
  function waitForCartUtils(callback, maxAttempts = 50) {
    let attempts = 0;
    const check = () => {
      if (window.CartUtils) {
        callback();
      } else if (attempts < maxAttempts) {
        attempts++;
        setTimeout(check, 100);
      }
    };
    check();
  }

  waitForCartUtils(() => {
    console.log('🛒 Side Cart initialisé avec CartUtils');
    
    // Écouter les événements pour recharger les recommandations
    document.addEventListener('cart:updated', () => {
      setTimeout(() => {
        if (typeof window.loadCartUpsellRecommendations === 'function') {
          window.loadCartUpsellRecommendations(null, true);
        }
      }, 200);
    });
  });

})();
